module.exports = __webpack_public_path__ + "static/media/sy.34bde6eb.svg";